export default class BlackListDto {
/**
 *
 * @type {string}
 * @memberof BlackListDto
 */
id?: any
/**
 *
 * @type {string}
 * @memberof BlackListDto
 */
regionId?: any
/**
 *
 * @type {string}
 * @memberof BlackListDto
 */
schoolShortName?: any | null
/**
 *
 * @type {string}
 * @memberof BlackListDto
 */
schoolCode?: any | null
/**
 *
 * @type {string}
 * @memberof BlackListDto
 */
vehicleNO?: any | null
/**
 *
 * @type {Date}
 * @memberof BlackListDto
 */
joinTime?: any
/**
 *
 * @type {string}
 * @memberof BlackListDto
 */
blackListTerm?: any | null
/**
 *
 * @type {Date}
 * @memberof BlackListDto
 */
relieveTime?: any | null
/**
 *
 * @type {string}
 * @memberof BlackListDto
 */
reason?: any | null
/**
 *
 * @type {boolean}
 * @memberof BlackListDto
 */
isDelete?: any
/**
 *
 * @type {string}
 * @memberof BlackListDto
 */
createBy?: any | null
/**
 *
 * @type {string}
 * @memberof BlackListDto
 */
reportPhone?: any | null
/**
 *
 * @type {string}
 * @memberof BlackListDto
 */
remark?: any | null
}
